const updateItems = [
  { time: '10分钟前', title: '17吃瓜黑料网独家：某女团成员夜店视频外泄，经纪公司紧急发声明', tag: '突发' },
  { time: '28分钟前', title: '17吃瓜爆料追踪：综艺导师私下收受选手礼物证据曝光', tag: '跟进' },
  { time: '1小时前', title: '17黑料吃瓜：网红直播带货翻车，产品含违禁成分被工商查处', tag: '热点' },
  { time: '2小时前', title: '内幕吃瓜：知名导演被多名女演员联名举报职场骚扰', tag: '深度' },
  { time: '3小时前', title: '娱乐圈黑料：某经纪公司内部邮件泄露，艺人合同暗藏霸王条款', tag: '独家' },
  { time: '4小时前', title: '17c吃瓜黑料爆料：选秀节目投票数据造假证据链完整公开', tag: '实锤' },
  { time: '5小时前', title: '粉丝爆料：流量小生与经纪人恋情曝光，已同居超过半年', tag: '热议' },
];

const tagColors: Record<string, string> = {
  '突发': 'bg-primary-500',
  '跟进': 'bg-accent-500',
  '热点': 'bg-primary-500',
  '深度': 'bg-secondary-500',
  '独家': 'bg-accent-500',
  '实锤': 'bg-primary-500',
  '热议': 'bg-secondary-500',
};

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[860px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-primary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            最新快讯
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 实时滚动更新</span>
        </div>

        <div className="relative pl-6 md:pl-8 border-l-2 border-background-200">
          {updateItems.map((item, idx) => (
            <div key={idx} className="relative mb-6 last:mb-0">
              <div className="absolute -left-[25px] md:-left-[33px] top-1 w-3 h-3 md:w-4 md:h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
              <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                <span className={`px-2 py-0.5 rounded text-[10px] font-bold text-background-50 whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-500'}`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed cursor-pointer hover:text-primary-600 transition-colors duration-200">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}